module.exports = __webpack_public_path__ + "img/image3.627000ab.jpg";